// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  basketClear as basketClearAction,
  basketClearValidatedAndWaiting as basketClearValidatedAndWaitingAction,
  basketGetSelection as basketGetSelectionAction,
  basketAcceptChanges as basketAcceptChangesAction,
  basketSubmit as basketSubmitAction,
} from '../../actions/basket';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';

import BasketCtas from './BasketCtas';
import selectBasketCtasProps from './BasketCtas.selector';

type PropsType = {
  className?: string;
};

const BasketCtasContainer = (ownProps: PropsType) => {
  const { history } = useRouter();
  const dispatch = useDispatch();

  const selectorProps = useMemo(() => ({ history }), [history]);
  const selectedProps = useSelector((state) => selectBasketCtasProps(state, selectorProps));

  const basketClear = useCallback(() => dispatch(basketClearAction()), [dispatch]);
  const basketClearValidatedAndWaiting = useCallback(
    () => dispatch(basketClearValidatedAndWaitingAction()),
    [dispatch],
  );
  const basketGetSelection = useCallback(() => dispatch(basketGetSelectionAction()), [dispatch]);
  const basketAcceptChanges = useCallback(() => dispatch(basketAcceptChangesAction()), [dispatch]);
  const basketSubmit = useCallback(() => dispatch(basketSubmitAction()), [dispatch]);

  const otherProps = useMemo(
    () => ({
      basketClear,
      basketClearValidatedAndWaiting,
      basketGetSelection,
      basketAcceptChanges,
      basketSubmit,
    }),
    [basketAcceptChanges, basketClear, basketClearValidatedAndWaiting, basketGetSelection, basketSubmit],
  );

  const enhancedProps = useMergeProps({ selectedProps, otherProps, ownProps });

  return <BasketCtas {...enhancedProps} />;
};

export default BasketCtasContainer;
